import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-muted-foreground">Strona nie istnieje</p>
      <Button asChild>
        <Link to="/">Wróć na stronę główną</Link>
      </Button>
    </div>
  )
}
